import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = '3tched-theme';
const read = () => document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light';

// Theme is applied to <html data-theme> before React renders (see public/index.html); this hook keeps it in sync.
export const useTheme = () => {
  const [theme, setTheme] = useState(read);
  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);
  useEffect(() => {
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const follow = event => { if (!localStorage.getItem(STORAGE_KEY)) setTheme(event.matches ? 'dark' : 'light'); };
    media.addEventListener('change', follow);
    return () => media.removeEventListener('change', follow);
  }, []);
  const toggle = useCallback(() => setTheme(current => (current === 'dark' ? 'light' : 'dark')), []);
  return { theme, toggle };
};
